import React, { useState, useEffect } from 'react';

import { NumberFormatInputbox } from './UIComponents.js';

const PaginationComponent = (props) => {
    const [currentPage, setCurrentPage] = useState(props.currentPage);
    const [totalPages, setTotalPage] = useState(props.totalPages);
    // const [searchTerm, setSearchTerm] = useState('');


    useEffect(() => {
        setCurrentPage(props.currentPage);
        setTotalPage(props.totalPages);
        //onPageChange(props.currentPage)
    }, [props.currentPage, props.totalPages]);

    // useEffect(() => {

    //     onPageChange(props.currentPage);

    // }, [props.currentPage]);




    const getPageNumbers = () => {
        const pages = [];
        const currentPage = parseInt(props.currentPage);
        const totalPages = parseInt(props.totalPages);

        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            if (currentPage <= 3) {
                pages.push(1, 2, 3, 4, '...', totalPages);
            } else if (currentPage >= totalPages - 2) {
                pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } else {
                pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
            }
        }
        return pages;
    };

    const handleOnchange = (e) => {
        setCurrentPage(e.target.value)
        props.handleOnchange(e)
    }
    const handlePaginationOnBlur = (e) => {

        props.handlePaginationOnBlur(e)

    }

    const onPageChange = (pageNumber) => {

        setCurrentPage(pageNumber);
        props.onPageClick(pageNumber); // Optional callback
    };
    const loadPrevious = (e) => {


        if (e.detail === 1) props.loadPrevious();
    };
    const loadNext = (e) => {
        if (e.detail === 1) props.loadNext();
    };


    return (
        <div>
            <div className="pagination_new-container_V1">
                <span className="custom_module_pageNumber_V1">
                    PAGE  -
                    <NumberFormatInputbox
                        name="currentPage"
                        value={currentPage}
                        className="customPaginationInput"
                        onChange={handleOnchange}
                        onBlur={
                            handlePaginationOnBlur
                        }
                        disabled={totalPages === 0}
                    />  OF{" "}
                    {parseInt(totalPages)}
                </span>
                <div className="pagination-container_V1">
                    {totalPages > 0 && (
                        <button
                            className="pagination-btn1"
                            // disabled={currentPage === 1}
                            onClick={(e) => loadPrevious(e)}
                        >
                            ◀ Prev
                        </button>
                    )}

                    {/* {getPageNumbers().map((page, index) => (
                    
                    <button
                        key={index}
                        className={`pagination-btn ${page === currentPage ? 'active' : ''}`}
                        onClick={() => typeof page === 'number' && onPageChange(page)}
                        // disabled={page === '...'}
                    >
                        {page}
                    </button>
                    
                ))} */}

                    {getPageNumbers().map((page, index) => {
                        const isActive = page === Number(currentPage);  // 🔧 Ensures type match
                        // console.log('Rendering Page Button:', {
                        //     page,
                        //     currentPage,
                        //     isActive,
                        //     pageType: typeof page,
                        //     currentPageType: typeof currentPage
                        // });

                        return (
                            <button
                                key={index}
                                className={`pagination-btn ${isActive ? 'active' : ''}`} // ✅ apply active class
                                onClick={() => typeof page === 'number' && onPageChange(page)}
                            >
                                {page}
                            </button>
                        );
                    })}
                    {totalPages > 0 && (
                        <button
                            className="pagination-btn1"
                            disabled={currentPage === totalPages}
                            onClick={(e) => loadNext(e)}
                        >
                            Next ▶
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PaginationComponent;